import { useCallback } from 'react';
import { TableV2 } from '../../../components/TableV2';
import { useQueryDrawer } from '../../../features/QueryDrawer/hooks/useQueryDrawer';
import { useActions, useColumns, useWorkspaceQueryList } from '../hooks';

const PAGINATION_LIST_OPTIONS = {
	suspense: true,
};

export function WorkspaceQueriesTable({
	lookBackDays,
}: {
	lookBackDays: number;
}) {
	const { openQuery } = useQueryDrawer();

	const columns = useColumns();
	const actions = useActions();

	const workspaceQueryList = useWorkspaceQueryList(lookBackDays);

	const onCellClick = useCallback(
		(cell) => {
			if (cell.column.navigate !== false) {
				openQuery(cell.record);
			}
		},
		[openQuery]
	);

	return (
		<TableV2
			pluralTypeString="queries"
			// @ts-ignore
			columns={columns}
			// @ts-ignore
			usePaginationList={workspaceQueryList}
			withActions={actions}
			withCheckbox={false}
			withStickyColumn={false}
			withInteractiveHeader
			withSearch
			withSort={false}
			defaultSort={null}
			onCellClick={onCellClick}
			usePaginationListOptions={PAGINATION_LIST_OPTIONS}
		/>
	);
}
